import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import SEO from "../components/SEO";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="max-w-[1600px] mx-auto">
      <SEO
        title="Polar Trek Adventure | Kashmir Tours & Trekking"
        description="Book Kashmir tour packages, trekking, Gulmarg, Sonmarg & adventure trips."
      />

      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
